import { render, staticRenderFns } from "./TeachingLearningChart.vue?vue&type=template&id=f3771e34&scoped=true"
import script from "./TeachingLearningChart.vue?vue&type=script&lang=js"
export * from "./TeachingLearningChart.vue?vue&type=script&lang=js"
import style0 from "./TeachingLearningChart.vue?vue&type=style&index=0&id=f3771e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3771e34",
  null
  
)

export default component.exports